module.exports = "<p>\n  dept-exam-auth-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Departmental-Exam/dept-exam-authorization/dept-exam-auth-form/dept-exam-auth-form.component.html
// module id = ./src/app/hrms/Departmental-Exam/dept-exam-authorization/dept-exam-auth-form/dept-exam-auth-form.component.html
// module chunks = main